import { render, staticRenderFns } from "./LottItem.vue?vue&type=template&id=12fc41ba&"
import script from "./LottItem.vue?vue&type=script&lang=js&"
export * from "./LottItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports